angular.module('impactx.comments').directive('ixAttachmentRequired', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            scope.$watch(attrs.ixAttachmentRequired, function () {
                ngModelCtrl.$setValidity("attachmentRequired", !scope.$eval(attrs.ixAttachmentRequired));
            });
        }
    };
});